import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LandingPage from './LandingPage/Container';

export default class App extends Component {
  static propTypes = {
    t: PropTypes.func,
  };

  render() {
    const { t } = this.props;

    return (
      <div>
        <LandingPage/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js